import { FormType } from '../../../form-types';
import { ZaludBacterialVaginosisQuestionFieldAnswers } from './questions';

const bacterialVaginosis: FormType<ZaludBacterialVaginosisQuestionFieldAnswers> =
  {
    name: 'Bacterial Vaginosis Intake',
    questions: [
      'zalud_bacterialVaginosis_feverPelvicPain',
      'zalud_bacterialVaginosis_soresUlcersBumps',
      'zalud_bacterialVaginosis_abnormalBleeding',
      'zalud_bacterialVaginosis_retainedObject',
      'zalud_bacterialVaginosis_priorTreatmentFailed',
      'zalud_bacterialVaginosis_recentTreatmentReturned',
      'zalud_bacterialVaginosis_itchingBurningPrimary',
      'zalud_bacterialVaginosis_symptoms',
      'zalud_bacterialVaginosis_symptomLocation',
      'zalud_bacterialVaginosis_symptomOnset',
      'zalud_bacterialVaginosis_odorAfterIntercourse',
      'zalud_bacterialVaginosis_priorBVDiagnosis',
      'zalud_bacterialVaginosis_menstrualCycleTiming',
      'zalud_bacterialVaginosis_sexuallyActive',
      'zalud_bacterialVaginosis_numPartners3Months',
      'zalud_bacterialVaginosis_newPartner3Months',
      'zalud_bacterialVaginosis_partnerSex',
      'zalud_bacterialVaginosis_barrierProtectionFrequency',
      'zalud_bacterialVaginosis_partnerSTISymptoms',
      'zalud_bacterialVaginosis_hygieneProducts',
      'zalud_bacterialVaginosis_iud',
      {
        key: 'zalud_bacterialVaginosis_stiTestedRecently',
        next: {
          condition: { 'zalud_bacterialVaginosis_stiTestedRecently.yes_positive': true },
          key: 'zalud_bacterialVaginosis_stiDiagnosed',
          els: 'zalud_bacterialVaginosis_treatmentPreference'
        }
      },
      'zalud_bacterialVaginosis_stiDiagnosed',
      'zalud_bacterialVaginosis_treatmentPreference',
      'zalud_bacterialVaginosis_priorTreatmentEffectiveness',
      'zalud_bacterialVaginosis_additionalComments',
      {
        key: 'zalud_bacterialVaginosis_consent',
        next: {
          condition: { 'zalud_bacterialVaginosis_consent.proceed': true },
          key: 'zalud_bacterialVaginosis_complete',
          els: 'zalud_bacterialVaginosis_ineligible'
        }
      },
      'zalud_bacterialVaginosis_complete',
      'zalud_bacterialVaginosis_ineligible'
    ]
  };

export default bacterialVaginosis;
